import React, { useState, useEffect, FC } from 'react'
import { Table, Button, Input, Select, message } from 'antd'
import { EditableCell, EditableRow } from '@/components/YHEditTable/editTable'
import { YhBox } from '@/components/YhBox'
import { RouterParamType } from '@/model/navModel'
import { useInquiryContrastModel } from './inquiryContrastModel'
import { ColumnsType } from 'antd/lib/table'
import { IInquiryGoods, IInquiryGoodsResult, IInquiryGoodsForContrast } from '../../inquiryTypes'
import YhTootip from '@/components/YhTootip'
import YhDebounceSelect from '@/components/YhDounceSelect'
import useGlobalModel from '@/model/globalModel'
import { ISelectOption } from '@/components/YhFormBox/Types'
import { bigNumber, generateUniqueId } from '@/utils/utils'
export const Contrast: FC<RouterParamType & { type: 'one' | 'two' }> = ({ id, mode, type }) => {
    const { mavbList, mavbChoosedSupplierCode, mavbChoosedInquiryId, getInquiryList, getGoodsList, viceChoosedSupplierCode, setViceChoosedSupplierCode, changeViceInquiryList } =
        useInquiryContrastModel()
    const { fetchSupplierList } = useGlobalModel()

    const [list, setList] = useState<IInquiryGoodsForContrast[]>([])
    const [choosedInquiryId, setChoosedInquiryId] = useState<string | undefined>(undefined)

    const [inquiryCodeOptions, setInquiryCodeOptions] = useState<ISelectOption[]>([])

    useEffect(() => {
        setList([])
        setInquiryCodeOptions([])
        setViceChoosedSupplierCode({ ...viceChoosedSupplierCode, [type]: undefined })
        setChoosedInquiryId(undefined)
    }, [mavbChoosedSupplierCode, mavbChoosedInquiryId])

    useEffect(() => {
        setChoosedInquiryId(undefined)
        setList([])
        setInquiryCodeOptions([])
        if (viceChoosedSupplierCode[type]) {
            inquiryList(viceChoosedSupplierCode[type] as string)
        }
    }, [viceChoosedSupplierCode[type]])

    //切换询价单，获取商品列表
    useEffect(() => {
        if (choosedInquiryId) {
            goodsList(choosedInquiryId)
        }
    }, [choosedInquiryId])

    const inquiryList = (choosedSupplierCode: string) => {
        getInquiryList(choosedSupplierCode).then((res) => {
            if (res) {
                const { records } = res
                if (records && records.length > 0) {
                    setInquiryCodeOptions(records.map((i) => ({ value: i.id, label: i.inquiryCode })))
                }
            }
        })
    }
    const goodsList = (choosedInquiryId: string) => {
        getGoodsList(choosedInquiryId).then((res) => {
            if (res) {
                const { sumInquiryDetailsList } = res
                let mList = [...mavbList]
                let getList = [...(sumInquiryDetailsList ? sumInquiryDetailsList : [])]
                let newList: IInquiryGoodsForContrast[] = []

                mList.forEach((mItem) => {
                    const { materialCode } = mItem
                    if(materialCode){
                        const index = getList.findIndex((i) => i.materialCode === materialCode)
                    if (index !== -1) {
                        const material = getList[index]
                        getList.splice(index, 1)
                        newList.push({
                            ...material,
                            result: bigNumber.minus(material.price, mItem.price as string | number),
                        })
                    } else {
                        newList.push({
                            id: generateUniqueId(),
                            materialCode: '--',
                            materialName: '--',
                            unitName: '--',
                            brandName: '--',
                            model: '--',
                            price: 0,
                            note: '--',
                            result: 0,
                        })
                    }
                    }
                    
                })

                getList.forEach((item) => {
                    newList.push({
                        ...item,
                        result: 0,
                    })
                })
                while (newList.length < 15) {
                    newList.push({id: generateUniqueId()});
                }
                setList(newList)
            }
        })
    }

    const columns: ColumnsType<IInquiryGoodsForContrast> = [
        {
            title: '序号',
            width: 40,
            align: 'left',
            fixed: 'left',
            render: (t, r, i) => i + 1,
        },

        {
            title: '商品名称',
            width: 200,
            align: 'left',
            dataIndex: 'materialName',
            render: (text: string) => <YhTootip style={{ width: '100%' }} text={text} />,
        },

        {
            title: '商品编号',
            width: 180,
            align: 'left',
            dataIndex: 'materialCode',
            render: (text: string) => <YhTootip text={text} />,
        },
        // {
        //     title: '品牌',
        //     width: 200,
        //     align: 'left',
        //     dataIndex: 'brandName',
        //     render: (text: string) => <YhTootip text={text} />,
        // },
        {
            title: '单价',
            width: 80,
            align: 'left',
            dataIndex: 'price',
            fixed: 'right',
            render: (text: string) => <YhTootip text={text} />,
        },
        {
            title: '对比结果',
            width: 100,
            align: 'left',
            fixed: 'right',
            dataIndex: 'result',
            render: (text: number) => <span style={{ color: text > 0 ? 'red' : text < 0 ? 'blue' : '#000' }}>{text}</span>,
        },
    ]

    //过滤已选择的供应商
    const supeplierOptions = async (v:string) =>{
        const list =  await fetchSupplierList(v)
        const arr = [mavbChoosedSupplierCode, ...Object.values(viceChoosedSupplierCode)]
        return list.filter(i => !arr.includes(i.value))
    }

    useEffect(() => {
        changeViceInquiryList(type,'list',list)
    },[list])

    return (
        <div style={{ margin: '10px', width: 'calc((100vw - 285px) / 3)' }}>
            <YhBox>
                <div style={{ display: 'flex', padding: '0 10px 10px 10px' }}>
                    <YhDebounceSelect
                        style={{ flex: 1, marginRight: '10px' }}
                        showSearch
                        className="border-r-16"
                        placeholder="供应商"
                        fetchOptions={supeplierOptions}
                        onChange={(v, o) => {
                            // let newChoosedSupplierCode = v as string | undefined
                            // if(newChoosedSupplierCode === mavbChoosedSupplierCode){
                            //     newChoosedSupplierCode = undefined
                            // }
                            // let arr = Object.entries(viceChoosedSupplierCode)
                            // let index = arr[0].findIndex(i => i === type)
                            // arr[1].forEach((item,i) => {
                            //     if(index !== i && newChoosedSupplierCode === item){
                            //         newChoosedSupplierCode = undefined
                            //     }
                            // })
                            // if(!newChoosedSupplierCode){
                            //     message.error("供应商不可重复选择")
                            // }
                            changeViceInquiryList(type,'supplierCode',v)
                            changeViceInquiryList(type,'supplierName',(o as {label: string}).label)
                            setViceChoosedSupplierCode({ ...viceChoosedSupplierCode, [type]: v })
                        }}
                        value={viceChoosedSupplierCode[type]}
                    />
                    <Select
                        style={{ flex: 1 }}
                        showSearch
                        className="border-r-16"
                        placeholder="询价单号"
                        options={inquiryCodeOptions}
                        value={choosedInquiryId}
                        onChange={(v,o) => {
                            changeViceInquiryList(type,'inquiryCode',(o as {label: string}).label)
                            setChoosedInquiryId(v as string)
                        }}
                    />
                </div>
                <Table
                   style={{ width: 'calc((100vw - 285px) / 3)', minHeight:"680px" }}
                    rowKey={(record) => record.id}
                    columns={columns}
                    dataSource={list}
                    pagination={false}
                    scroll={{ x: 'max-content' , y: '640px'}}
                    locale={{
                        emptyText: <div style={{ minHeight: '600px', textAlign: 'center', lineHeight: '600px' }}>暂无数据</div>,
                    }}
                />
            </YhBox>
        </div>
    )
}
